<template>
  <div id="app">
    <div class="header">
      <div class="nav">
        <div class="img-logo">
          <img src="https://pgyh5.oss-cn-hangzhou.aliyuncs.com/zyWeb/index_logo.png">
          <!-- <div class="img-title"></div> -->
        </div>
        <div class="center-nav pointer-hover">
          <div class="nav-item" :class="[tap == 'index' ? 'active' : '']" @click="navTap('index')">首页</div>
          <div class="nav-item" :class="[tap == 'profile' ? 'active' : '']" @click="navTap('profile')">公司简介</div>
          <div class="nav-item" :class="[tap == 'cooperation' ? 'active' : '']" @click="navTap('cooperation')">招商合作</div>
          <div class="nav-item" :class="[tap == 'join' ? 'active' : '']" @click="navTap('join')">加入我们</div>
        </div>
        <div class="header-right">
          <div class="ad">广告发布</div>
          <div class="server">
            <div class="server-text">
              <img class="server-icon" src="./assets/index/server_icon.png" />
              <span>客服热线</span>
            </div>
            <div class="server-tel">400-1635008</div>
          </div>
        </div>
      </div>
    </div>
    <router-view />
    <div class="footer">
      <span class="footer-nav pointer-hover" @click="navTap('index')">首页</span>
      <span class="footer-nav pointer-hover" @click="navTap('profile')">公司简介</span>
      <span class="footer-nav pointer-hover" @click="navTap('cooperation')">招商合作</span>
      <span class="footer-nav pointer-hover" @click="navTap('join')">加入我们</span>
      <span class="pointer-hover">©2021 福州中移信息科技有限公司 <a class="ipc" href="https://beian.miit.gov.cn/#/Integrated/index">闽ICP备2021005981号-1</a></span>
      <img style="margin-left: 5px" :src="IMG+'/pic.gif'">
    </div>
  </div>
</template>
<script>
export default {
  name: 'App',
  data() {
    return {
      IMG: this.img_host,
      tap: this.$getSessionStorage('nav_tap') || 'index',
    }
  },
  // 页面创建前
  beforeCreate() {
    // document.querySelector('body').setAttribute('style', 'background:#f7f7f7');
  },
  mounted() {
    this.$broadcast.$on('nav_tap', (res) => {
      this.navTap(res)
    })
  },
  methods: {
    navTap(tap) {
      if (tap == this.tap) return;
      this.tap = tap;
      this.$setSessionStorage({ key: 'nav_tap', data: tap });
      this.$router.push({ name: tap });
    }
  }
}

</script>
<style>
html {
  background: #f7f7f7;
}

body {
  margin: 0;
}

#app .header {
  width: 100vw;
  min-width: 1200px;
  background: #fff;
  display: flex;
  justify-content: center;
  padding: 10px 0;
}

#app .header .nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 1200px;
}

#app .header-right {
  display: flex;
  align-items: center;
}

#app .header-right .ad {
  font-size: 14px;
  color: #3889fc;
  margin-right: 20px;
}

#app .header-right .server {
  font-size: 10px;
  color: #333;
  line-height: 1;
  text-align: center;
}

#app .header-right .server-icon {
  width: 10px;
  height: 10px;
  margin-right: 2px;
}

#app .header-right .server-tel {
  color: #3889fc;
  margin-top: 2px;
}

.pointer-hover:hover {
  cursor: pointer
}

.nav .center-nav {
  display: inline-flex;
  flex: 1;
  padding-left: 40px;
}

.nav .center-nav .nav-item {
  font-size: 18px;
  color: #111;
  padding: 10px 20px;
  position: relative;
}

.nav .center-nav .active {
  color: #3889fc;
}

.nav .center-nav .active:before {
  content: '';
  width: 50%;
  border-top: 3px solid #3889fc;
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
}

.nav .img-logo img {
  width: 136px;
  height: 42px;
}

.nav .img-logo .img-title {
  color: #e36612;
  font-size: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 30px;
}

.footer {
  height: 100px;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}

.footer .footer-nav {
  font-size: 14px;
  color: #666;
  margin-right: 6px;
}

.footer .ipc {
  text-decoration: none;
  color: #333;
}

</style>



// WEBPACK FOOTER //
// src/App.vue